// extracted by mini-css-extract-plugin
module.exports = {"check":"EmployeeAttendanceTableRow__check--1LpB8"};